var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"cookie-banner"},[_c('p',[_vm._v(" We use cookies to improve your experience. ")]),_c('button',{on:{"click":_vm.reject}},[_vm._v("Reject All")]),_c('button',{on:{"click":_vm.accept}},[_vm._v("Accept All")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }